"use client";

import Image from "@/app/components/ProtectedImage";
import Link from "next/link";
import { useTranslations, useLocale } from "@/i18n/TranslationProvider";
import { buildMediaPath } from "@/lib/mediaPaths";

const wordmarkPath = buildMediaPath(
    "/branding/ena-wordmark-zh.png",
);

export default function MobileInfoSection() {
    const t = useTranslations();
    const locale = useLocale();

    return (
        <section className="sm:hidden bg-white px-4 py-6 border-b border-gray-200">
            <div className="text-center">
                <div className="mb-4">
                    <Image
                        src={wordmarkPath}
                        alt={`${t.common.brandFull}`}
                        width={100}
                        height={40}
                        className="mx-auto object-contain"
                    />
                </div>

                <div className="mb-6">
                    <a
                        href={`tel:${t.common.phone}`}
                        className="inline-flex items-center text-black font-bold text-xl"
                    >
                        <svg
                            className="w-5 h-5 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                        </svg>
                        {t.common.phone}
                    </a>
                </div>

                <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-black font-medium text-sm tracking-wide">
                    <Link href={`/${locale}/special-offers`} className="hover:text-black">
                        {t.home.mobileLinks.specialOffers}
                    </Link>
                    <span className="text-black">|</span>
                    <Link href={`/${locale}/ev-offers`} className="hover:text-black">
                        {t.home.mobileLinks.evOffers}
                    </Link>
                    <span className="text-black">|</span>
                    <Link href={`/${locale}/loan-lease`} className="hover:text-black">
                        {t.home.mobileLinks.loanLease}
                    </Link>
                    <span className="text-black">|</span>
                    <Link href={`/${locale}/used-cars`} className="hover:text-black">
                        {t.home.mobileLinks.usedCars}
                    </Link>
                </div>
            </div>
        </section>
    );
}
